module.exports = __webpack_public_path__ + "img/shop_logo.ea7de85a.png";